var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.827833C0 0.370633 0.370792 0 0.827833 0H14.1722C14.6293 0 15 0.370792 15 0.827833V14.1722C15 14.6293 14.6292 15 14.1722 15H0.827833C0.370633 15 0 14.6292 0 14.1722V0.827833ZM6.35158 4.51216C6.29683 4.47565 6.2325 4.45617 6.16667 4.45617C5.98258 4.45617 5.83333 4.60541 5.83333 4.78951V10.2105C5.83333 10.2763 5.85283 10.3407 5.88933 10.3954C5.99142 10.5486 6.19842 10.59 6.35158 10.4878L10.4173 7.77733C10.4539 7.75292 10.4853 7.7215 10.5097 7.68492C10.6119 7.53175 10.5705 7.32475 10.4173 7.22267L6.35158 4.51216Z",
  fill: "black"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkIcon);
export { ForwardRef as ReactComponent };